import { render, staticRenderFns } from "./CustomGoogleAutoComplete.vue?vue&type=template&id=3aaf56a0&"
import script from "./CustomGoogleAutoComplete.vue?vue&type=script&lang=js&"
export * from "./CustomGoogleAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports